import { TbLayoutDashboard } from 'react-icons/tb';
import type { IconProps } from './IconBase';
import { IconBase } from './IconBase';

export const DashboardIcon = (props: IconProps) => {
  return <IconBase icon={TbLayoutDashboard} {...props} />;
};
